export default function OfferStrip({ stats }) {
  const s = stats || { founders_claimed: 0, founders_total: 45, passes_claimed: 0, passes_total: 55, all_closed: false };
  const items = [
    [`${s.founders_claimed}/${s.founders_total}`, s.founders_closed ? "free spots — full" : "free founding spots"],
    [`${s.passes_claimed}/${s.passes_total}`, s.passes_closed ? "pass spots — full" : "Matcha Pass spots"],
    ["Uji + Shizuoka", "two grades, never substituted"],
    [s.all_closed ? "100/100" : "Dehradun", s.all_closed ? "founding 100 closed" : "opening soon"],
  ];

  return (
    <section
      className="border-y border-border bg-[#EBEFDE]/40 py-5 px-6 md:px-10"
      data-testid="offer-strip"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-4">
        {items.map(([k, v], i) => (
          <div key={i} className="flex items-baseline gap-3" data-testid={`offer-strip-item-${i}`}>
            <span className="font-serif text-2xl md:text-3xl text-[#2C4C3B] tabular-nums">{k}</span>
            <span className="text-xs uppercase tracking-[0.16em] text-[#5C7365]">{v}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
